import { useApiClient } from '~/api-client';
import { EventPanelResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { TAB_QUERY_CACHE_TIME } from '../tabs/constants';
import { HoistedQueryProps } from './types';

export function useEventRelatedDataExistingEventQuery(props: {
    eventId?: number;
    lastUpdatedDateUtc?: string;
    hoistedQueryProps?: HoistedQueryProps;
}) {
    const apiClient = useApiClient();
    return useQuery(
        ['eventData', props.eventId, props.lastUpdatedDateUtc],
        ({ queryKey }) => {
            const eventIdFromQueryKey = queryKey[1];
            const eventId =
                typeof eventIdFromQueryKey === 'number'
                    ? props.eventId
                    : typeof eventIdFromQueryKey === 'string'
                    ? parseInt(eventIdFromQueryKey, 10)
                    : undefined;
            return apiClient
                .request<EventPanelResource.GetEventPanelView>({
                    method: 'POST',
                    url: 'event_panel/',
                    data: {
                        eventId,
                        form: true,
                        configuration: false,
                        options: false,
                        metadata: false,
                    },
                })
                .then((resp) => {
                    return resp.data.data?.form;
                });
        },
        {
            cacheTime: TAB_QUERY_CACHE_TIME,
            ...props.hoistedQueryProps,
        }
    );
}
